import { render, staticRenderFns } from "./MobileNameheader.vue?vue&type=template&id=27ab9088"
import script from "./MobileNameheader.vue?vue&type=script&lang=js"
export * from "./MobileNameheader.vue?vue&type=script&lang=js"
import style0 from "./MobileNameheader.vue?vue&type=style&index=0&id=27ab9088&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports